import {
  APIData,
  emptyIndirectAPIData,
  emptyResults,
} from 'Common/utilities/apidata';
import { PullRequest } from 'models/PullRequest';
import { getStore as getRootStore } from 'stores/common/selectors';

const selectedReview = (state: any): PullRequest | null => {
  const store = getRootStore(state);
  return store.security.selection.pullRequest ?? null;
};
export function entries(state: any) {
  const store = getRootStore(state);
  return store.pullRequests.entries ?? emptyIndirectAPIData;
}

export function entry(state: any): APIData<PullRequest> {
  const review = selectedReview(state);
  const uuid = review?.uuid;
  if (uuid === undefined) {
    return emptyResults;
  }
  const prEntries = entries(state);
  return prEntries[uuid] ?? emptyResults;
}

export function entryData(state: any): PullRequest | undefined {
  const prEntry = entry(state);
  if (!prEntry.isFilled || !prEntry.success) {
    return undefined;
  }
  return prEntry.data;
}

export function isToggling(state: any): boolean {
  const review = selectedReview(state);
  const uuid = review?.uuid;
  if (uuid === undefined) {
    return false;
  }

  const store = getRootStore(state);
  const toggleEntries = store.pullRequests.toggleReview[uuid] || emptyResults;
  return toggleEntries.isLoading;
}

export const entryError = (state: any) => {
  const review = selectedReview(state);
  const uuid = review?.uuid;
  if (uuid === undefined) {
    return undefined;
  }

  const store = getRootStore(state);
  const toggleEntries = store.pullRequests.toggleReview[uuid] || emptyResults;
  return !toggleEntries.success ? toggleEntries.errorData : undefined;
};

export const selectors = { selectedReview, entryData, entryError, isToggling };
